import React from 'react';
import { Switch } from '@mui/material';

export const SwitchBlock = ({ setting, onValueChange }) => {
    const handleChange = (event) => {
        const newValue = event.target.checked ? "true" : "false";
        onValueChange(setting.id, newValue);
    };

    return (
        <Switch
            disabled={!setting.is_active}
            checked={setting.parameter_value === "true"}
            onChange={handleChange}
            color="primary"
            inputProps={{
                "aria-label": `toggle ${setting.title}`,
            }}
        />
    );
};
